import autoComplete from "@tarekraafat/autocomplete.js";

const searchAutocomplite = ({autocompliteSelector = `.autocomplite`}) => {
  document.querySelectorAll(autocompliteSelector).forEach((element, index) => {
    const className = `autocomplite-${index + 1}`;

    element.classList.add(className);

    const autoCompleteJS = new autoComplete({
      selector: `.${className}`,
      placeHolder: "Поиск по каталогу",
      debounce: 300,
      submit: true,
      data: {
        src: async (query) => {
          try {
            // const source = await fetch(`/data/search.json?search=${query}&ajax=search`);
            const source = await fetch(`/search?search=${query}&ajax=search`);
            const data = await source.json();
            return data;
          } catch (error) {
            return error;
          }
        },
        keys: ["name", "tags", "collectionName", "tagName"],
        // cache: true,
      },
      resultsList: {
        element: (list, data) => {
          if (!data.results.length) {
            const message = document.createElement("div");
            message.classList.add(`autoComplite_no-result`);
            message.innerHTML = `<span>По запросу "${data.query}" ничего не найдено</span>`;
            list.prepend(message);
          }
        },
        noResults: true,
        maxResults: 20,
      },
      resultItem: {
        element: (item, data) => {
          // Modify Results Item Content
          const {value, match} = data;
          switch (value.type) {
            case `product`:
              item.innerHTML = `<a href="${value.url}" class="autoComplite_link">
              <span class="autoComplite_name">
                ${value.name}
              </span>
              <span class="autoComplite_category">
                ${value.category}
              </span></a>
              <a class="autoComplite_link autoComplite_link--author" href="${value.authorUrl}">${value.authorName}</a>`;
              break;
            case `collection`:
              item.innerHTML = `<a href="${value.url}" class="autoComplite_link">
              <span class="autoComplite_name">
                ${value.name}
              </span>
              <span class="autoComplite_category">
                ${value.category}
              </span></a>
              <a class="autoComplite_link autoComplite_link--author" href="${value.collectionUrl}">${value.collectionName}</a>`;
              break;
            case `tag`:
              item.innerHTML = `<a href="${value.url}" class="autoComplite_link">
              <span class="autoComplite_name">
                ${value.name}
              </span>
              <span class="autoComplite_category">
                ${value.category}
              </span></a>
              <a class="autoComplite_link autoComplite_link--author" href="${value.tagUrl}">${value.tagName}</a>`;
              break;
            case `author`:
              item.innerHTML = `<a href="${value.url}" class="autoComplite_link">
              <span class="autoComplite_name">
                ${value.name}
              </span>
              <span class="autoComplite_category">
                ${value.category}
              </span></a>`;
              break;
          }
        },
        highlight: {
          render: true,
        },
      },
    });

    autoCompleteJS.input.addEventListener("selection", function (event) {
      const feedback = event.detail;
      console.log(event);
      console.log(autoCompleteJS);
      if (feedback.event.key === "Enter") {
        document
          .querySelector(`.${className}`)
          .closest(`.search__form`)
          .addEventListener(`submit`, (evt) => {
            evt.preventDefault();
          });
        console.log(`${location.origin}${feedback.selection.value.url}`);
        location.href = `${location.origin}${feedback.selection.value.url}`;
      }
    });
  });
};

export default searchAutocomplite;
